export default __webpack_public_path__ + "static/media/pizza.54a32c6d.png";